var $feedbacker = null;
var feedbacker_init = () => {

  var $ = jQuery;
  $feedbacker = $('.feedbacker');
  // $feedbacker.fadeOut('fast');
}
var feedbacker_show_message = (arg, messageType='') => {

  $feedbacker.html(arg);
  $feedbacker.addClass('active feedbacker-active');

  $feedbacker.removeClass('is-success is-error');
  if(messageType){

    $feedbacker.removeClass(messageType);
  }
  setTimeout(function () {

    $feedbacker.removeClass('active feedbacker-active');
  }, 1500)
}

exports.feedbacker_init = feedbacker_init;
exports.feedbacker_show_message = feedbacker_show_message;